import Document from '@/common/page_comp/Documents/document.js';
import { DOCUMENT_STATE_NORMAL } from '@/common/page_comp/Documents/document.states.js';


export default class {
    id = null;
    value = {
        name: '',
        accessType: 'PUBLIC',
        documents: [],
    };

    state = DOCUMENT_STATE_NORMAL;
    removed = false;
    checked = false;

    canRemove = false;
    canRestore = false;
    canEdit = false;
    canSelect = false;


    constructor(group) {
        this.id = group.id;
        this.value = {
            name: group.name,
            accessType: group.accessType,
            documents: group.documents?.map(it => new Document(it)) ?? [],
        };
    }

    addFiles(files = []) {
        for (const it of files) {
            if (it instanceof Document) {
                if (this.value.documents.find(doc => doc.id === it.id))
                    continue;

                this.value.documents.push(it);
            } else {
                this.value.documents.push(new Document(it));
            }
        }
    }

    removeFiles(files = []) {
        for (const it of files) {
            const index = this.value.documents.findIndex(doc => doc.id === it.id);
            if (index >= 0) {
                this.value.documents.splice(index, 1);
            }
        }
    }

    clearRemoved() {
        this.value.documents = this.value.documents.filter(doc => !doc.removed);
    }
}
